module.exports = __webpack_public_path__ + "img/ic-tool.158f1333.svg";